import { createContext, Dispatch, SetStateAction } from 'react';

import { UserInfo } from '@/common/types/user';

import { PlainObject } from '../types';

export interface GFlags extends PlainObject {
  // anything
}

export interface GContext {
  IS_IN_ADMIN?: boolean;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  userInfo?: UserInfo;
  globalFlags: GFlags;
  restData?: PlainObject;
}

export const GContextInit = {
  IS_IN_ADMIN: false,
  loading: false,
  setLoading: (() => {}) as Dispatch<SetStateAction<boolean>>,
  userInfo: {} as UserInfo,
  globalFlags: {
  },
  restData: {},
};

export const GlobalContext = createContext<GContext>(GContextInit);
